export default "__VITE_ASSET__CkivguIp__"